import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, UserCircle, ArrowRight } from 'lucide-react';
import { useProfileCompletion } from '@/hooks/useProfileCompletion';

const SESSION_KEY = 'fluity_profile_popup_dismissed';

export function ProfileCompletionPopup() {
  const { isProfileComplete, loading } = useProfileCompletion();
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (isProfileComplete !== false) return;
    if (sessionStorage.getItem(SESSION_KEY)) return;

    const timer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(timer);
  }, [loading, isProfileComplete]);

  const dismiss = () => {
    sessionStorage.setItem(SESSION_KEY, '1');
    setVisible(false);
  };

  const goToProfile = () => {
    dismiss();
    navigate('/profile');
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-6 right-6 z-[500] w-[320px] rounded-2xl shadow-xl border border-[#e0e7ff] bg-white overflow-hidden animate-in slide-in-from-bottom-4 fade-in duration-300"
      style={{ boxShadow: '0 8px 28px rgba(37,99,235,0.35)' }}
    >
      {/* Blue accent bar */}
      <div className="h-1 w-full" style={{ background: '#2563EB' }} />

      <div className="p-4">
        <div className="flex items-start gap-3">
          <div
            className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ background: '#2563EB15' }}
          >
            <UserCircle className="w-5 h-5" style={{ color: '#1d4ed8' }} />
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-[13px] font-semibold text-[#0f172a] leading-snug">
              Finalize seu cadastro
            </p>
            <p className="text-[12px] text-[#64748b] mt-0.5 leading-snug">
              Complete seu perfil para aproveitar todos os recursos da plataforma.
            </p>
          </div>

          <button
            onClick={dismiss}
            className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-[#94a3b8] hover:text-[#64748b] hover:bg-[#f1f5f9] transition-colors"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>

        <button
          onClick={goToProfile}
          className="mt-3 w-full py-2 rounded-xl text-[12px] font-semibold text-white flex items-center justify-center gap-1.5 transition-opacity hover:opacity-95 shadow-[0_4px_16px_rgba(37,99,235,0.45)]"
          style={{ background: '#2563EB' }}
        >
          Completar agora
          <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
